import { sample } from "effector"
import { userApi, windowApi } from "@callcenter/api"

import { modalOpened, modalClosed } from "./user-account.model"
import { restore as restoreCooldown, stateReset } from "./email-confirmation.model"
import { userAccountApi } from "../../api"

sample({
  clock: modalOpened,
  // TODO: verify reconnectSessionFx is redundant here (result unused; refetch already via
  // resetCurrentSessionFx.done) and drop it.
  target: [userApi.resetCurrentSessionFx, userApi.reconnectSessionFx, restoreCooldown]
})

sample({
  clock: modalClosed,
  target: stateReset
})

sample({
  clock: userAccountApi.userProfileSaveFx.doneData,
  target: windowApi.reloadFx
})
